import { configureStore, Store } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { userApiSlice } from "../common/api/user";
import { productRangeReducer } from "../pages/productRangePage/ProductRangeSlice";
import { collectionsReducer } from "../pages/collectionsPage/CollectionsSlice";
import { accountReducer } from "../pages/accountPage/AccountSlice";
import { deleteCollectionModalReducer } from "../modals/deleteCollectionModal/DeleteCollectionModalSlice";
import { deleteCollectionProductModalReducer } from "../modals/deleteCollectionProductModal/DeleteCollectionProductModalSlice";
import { editCollectionModalReducer } from "../modals/editCollectionModal/EditCollectionModalSlice";
import { addCollectionProductsModalReducer } from "../modals/addCollectionProductsModal/AddCollectionProductsModalSlice";
import { productGalleryModalReducer } from "../modals/productGalleryModal/productGalleryModalSlice";
import { searchReducer } from "../pages/searchPage/SearchSlice";
import { addCollectionModalReducer } from "../modals/addCollectionModal/AddCollectionModalSlice";
import { PriceBookReducer } from "../pages/priceBookPage/PricebookSlice";
import { QueryMiddleware } from "./QueryMiddleware";
import { refurbishedReducer } from "../pages/refurbishedPage/RefurbishedSlice";
import { cartReducer } from "../pages/cartPage/CartSlice";
import { cartToastReducer } from "../common/slices/cartToastSlice";
import { refurbishedApiSlice } from "../common/api/refurbished";
import { productApiSlice } from "../common/api/product";
import { productDetailsApiSlice } from "../common/api/productDetails";
import { accountApiSlice } from "../common/api/account";
import { collectionsApiSlice } from "../common/api/collections";
import { searchApiSlice } from "../common/api/search";
import { documentsApiSlice } from "../common/api/documents";

export const store: Store = configureStore({
    reducer: {
        root: rootReducer,
        [userApiSlice.reducerPath]: userApiSlice.reducer,
        [accountApiSlice.reducerPath]: accountApiSlice.reducer,
        [collectionsApiSlice.reducerPath]: collectionsApiSlice.reducer,
        [productDetailsApiSlice.reducerPath]: productDetailsApiSlice.reducer,
        [searchApiSlice.reducerPath]: searchApiSlice.reducer,
        [documentsApiSlice.reducerPath]: documentsApiSlice.reducer,
        [refurbishedApiSlice.reducerPath]: refurbishedApiSlice.reducer,
        [productApiSlice.reducerPath]: productApiSlice.reducer,
        collections: collectionsReducer,
        productRange: productRangeReducer,
        account: accountReducer,
        search: searchReducer,
        productGalleryModal: productGalleryModalReducer,
        deleteCollectionModal: deleteCollectionModalReducer,
        deleteCollectionProductModal: deleteCollectionProductModalReducer,
        addCollectionModal: addCollectionModalReducer,
        editCollectionModal: editCollectionModalReducer,
        addCollectionProductsModal: addCollectionProductsModalReducer,
        priceBook: PriceBookReducer,
        refurbished: refurbishedReducer,
        cart: cartReducer,
        cartToast: cartToastReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat(
            userApiSlice.middleware,
            accountApiSlice.middleware,
            collectionsApiSlice.middleware,
            productDetailsApiSlice.middleware,
            searchApiSlice.middleware,
            documentsApiSlice.middleware,
            refurbishedApiSlice.middleware,
            productApiSlice.middleware,
            QueryMiddleware,
        ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
